module.exports = __webpack_public_path__ + "static/media/logo-gov_alagoas.8e606736.png";